import {
  Row
} from 'reactstrap'
import CardPromo from './CardPromo'
const ListPromo = (items : any) => {
  const {data} = items
  return (
    <div className="py-4">
      <Row>
        {(data.length > 0) && (
          data.map((val : object, i: number) => (
            <div className="ColPromo" key={i}>
              <CardPromo {...val} />
            </div>
          ))
        )}
      </Row>
    </div>
  )
}

export default ListPromo